import React, { Fragment, useContext, useEffect, useRef, useState } from 'react';
import { Card, CardHeader, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import CustomizerContext from "../../../_helper/Customizer";
import { H4 } from "../../../AbstractElements";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import 'datatables.net-bs5';
import ManageTransactions from "../../../api/ManageTransactions";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { TransactionTableHeader, UsersTableTitle } from '../../../Constant';

const TabClass = ({ transactions, reloadAction }) => {
    const { layoutURL } = useContext(CustomizerContext);
    const tableRef = useRef(null);
    const [loadingTransaction, setLoadingTransaction] = useState(null);
    const [isDeleteAllModalOpen, setIsDeleteAllModalOpen] = useState(false);
    const [isDeletingAll, setIsDeletingAll] = useState(false);
    const [transactionStatus, setTransactionStatus] = useState(false);

    const handleAction = async (id, status) => {
        setLoadingTransaction(id + status); // unique key for button
        try {
            const response = await ManageTransactions.updateTransactionStatus({
                id,
                status,
            });
            toast.success(`Transaction ${status === 'PAYED' ? 'validée' : 'rejetée'} avec succès`);
            reloadAction();
        } catch (error) {
            toast.error("Erreur lors de la mise à jour");
        } finally {
            setLoadingTransaction(null);
        }
    };

    const handleDeleteAllConfirm = async () => {
        setIsDeletingAll(true);
        try {
            await ManageTransactions.deleteAllNonInitTransactions();
            toast.success('Suppression effectuée avec succès');
            setIsDeleteAllModalOpen(false);
            reloadAction();
        } catch (error) {
            toast.error("Erreur lors de la suppression");
        } finally {
            setIsDeletingAll(false);
        }
    };

    const stopTransaction = async () => {
        try {
            console.log("stopTransaction");
            await ManageTransactions.stopTransaction();
            toast.success('Transaction arrêtée avec succès');
            setTransactionStatus(true)
            reloadAction();
        } catch (error) {
            toast.error("Erreur lors de l'arrêt des transactions");
        } finally {
            setIsDeletingAll(false);
        }
    }

    const enableTransaction = async () => {
        try {
            console.log("enableTransaction");
            await ManageTransactions.enableTransaction();
            toast.success('Transaction relancer avec succès');
            setTransactionStatus(false)
            reloadAction();
        } catch (error) {
            toast.error("Erreur lors de la relance des transactions");
        } finally {
            setIsDeletingAll(false);
        }
    }

    const getTransactionStatus = async () => {
        try {
            console.log("getTransactionStatus");
            const status = await ManageTransactions.getStopTransaction();
            console.log("getTransactionStatus", status);
            setTransactionStatus(status.data.data.stop_deposit)
        } catch (error) {
            toast.error("Erreur lors de la recharge");
        } finally {
            setIsDeletingAll(false);
        }
    }


    useEffect(() => {
        const $table = $(tableRef.current);

        if (!$.fn.DataTable.isDataTable(tableRef.current)) {
            $table.DataTable({
                order: [[0, 'desc']],
                language: {
                    processing:     "Traitement en cours...",
                    search:         "Rechercher&nbsp;:",
                    lengthMenu:     "Afficher _MENU_ éléments",
                    info:           "Affichage de l'élément _START_ à _END_ sur _TOTAL_ éléments",
                    infoEmpty:      "Affichage de l'élément 0 à 0 sur 0 élément",
                    infoFiltered:   "(filtré de _MAX_ éléments au total)",
                    infoPostFix:    "",
                    loadingRecords: "Chargement en cours...",
                    zeroRecords:    "Aucun élément à afficher",
                    emptyTable:     "Aucune donnée disponible dans le tableau",
                    paginate: {
                        first:      "Premier",
                        previous:   "Précédent",
                        next:       "Suivant",
                        last:       "Dernier"
                    },
                    aria: {
                        sortAscending:  ": activer pour trier la colonne par ordre croissant",
                        sortDescending: ": activer pour trier la colonne par ordre décroissant"
                    }
                },
                data: [],
                columns: TransactionTableHeader.map((header) => ({ title: header })),
            });
        }

        getTransactionStatus().catch(console.error);

        return () => {
            if ($.fn.DataTable.isDataTable(tableRef.current)) {
                $table.DataTable().destroy();
            }
        };
    }, []);

    useEffect(() => {
        if ($.fn.DataTable.isDataTable(tableRef.current)) {
            const table = $(tableRef.current).DataTable();
            table.clear();

            transactions.forEach((transaction) => {

                const isActionable = transaction.status === 'INIT' || transaction.status === 'FAILED';

                table.row.add([
                    transaction.created_at,
                    transaction.complete_name,
                    transaction.type,
                    transaction.operation_number,
                    transaction.bet_code,
                    transaction.source,
                    transaction.amount,
                    (transaction.country === 'TG') ? 'TOGO' : (transaction.country === 'CI') ? 'CÔTE D\'IVOIRE' : 'BÉNIN',
                    (() => {
                        switch (transaction.status) {
                            case 'INIT':       return '<span class="badge bg-primary">NOUVEAU</span>';
                            case 'PAYED':      return '<span class="badge bg-success">PAYÉ</span>';
                            case 'PROCESSING': return '<span class="badge bg-warning text-dark">EN COURS</span>';
                            case 'LOCKED':     return '<span class="badge bg-secondary">VERROUILLÉ</span>';
                            case 'FAILED':     return '<span class="badge bg-danger">ÉCHOUÉ</span>';
                            default:           return '<span class="badge bg-dark">ANNULÉ</span>';
                        }
                    })(),
                    `
                        <button class='btn btn-sm btn-primary validate-btn' 
                                data-id='${transaction.id}'
                                data-status='PAYED'
                                ${!isActionable ? 'disabled' : ''}>
                          ${loadingTransaction === transaction.id + 'PAYED'
                                    ? "<span class='spinner-border spinner-border-sm'></span>"
                                    : "<i class='fa fa-pencil'></i> Valider"}
                        </button>
                        <button class='btn btn-sm btn-danger reject-btn' 
                                data-id='${transaction.id}' 
                                data-status='ABORT'
                                ${!isActionable ? 'disabled' : ''}>
                          ${loadingTransaction === transaction.id + 'ABORT'
                                    ? "<span class='spinner-border spinner-border-sm'></span>"
                                    : "<i class='fa fa-trash'></i> Rejeter"}
                        </button>
                      `
                ]);
            });
            table.draw();
            // Attach click handlers
            $(tableRef.current).off('click', '.validate-btn, .reject-btn').on('click', '.validate-btn, .reject-btn', function () {
                const id = $(this).data('id');
                const status = $(this).data('status');
                handleAction(id, status);
            });
        }
    }, [transactions, loadingTransaction]);

    return (
        <Fragment>
            <ToastContainer />
            <Card>
                <CardHeader>
                    <div className="row align-items-center mb-3">
                        <div className="col">
                            <H4 attrH4={{ className: 'card-title mb-0' }}>
                                Tableau de la liste des transactions
                            </H4>
                        </div>
                        <div className="col-auto">
                            <button className='btn btn-danger' onClick={() => setIsDeleteAllModalOpen(true)} disabled={isDeletingAll}>
                                <i className='fa fa-trash me-2'></i>
                                {isDeletingAll ? (
                                    <span className='spinner-border spinner-border-sm'></span>
                                ) : (
                                    'Tout Supprimer'
                                )}
                            </button>
                        </div>
                        {transactionStatus ? (
                            <div className="col-auto">
                                    <button className='btn btn-success' onClick={() => enableTransaction()}>
                                        <i className='fa fa-play me-2'></i>
                                        Lancer transactions
                                    </button>
                            </div>
                        ) : (
                            <div className="col-auto">
                                <button className='btn btn-danger' onClick={() => stopTransaction()}>
                                    <i className='fa fa-stop-circle me-2'></i>
                                    Arrêter transactions
                                </button>
                            </div>
                        )}
                    </div>
                    <div className='card-options'>
                        <a className='card-options-collapse' href='#javascript' data-toggle='card-collapse'>
                            <i className='fe fe-chevron-up'></i>
                        </a>
                        <a className='card-options-remove' href='#javascript' data-toggle='card-remove'>
                            <i className='fe fe-x'></i>
                        </a>
                    </div>
                </CardHeader>
                <div className='table-responsive edit-table'>
                    <table
                        ref={tableRef}
                        className='display table table-striped table-vcenter text-nowrap'
                        style={{ width: '100%' }}
                    >
                        <thead>
                        <tr>
                            {TransactionTableHeader.map((header, i) => (
                                <th key={i}>{header}</th>
                            ))}
                        </tr>
                        </thead>
                        <tbody></tbody>
                    </table>
                </div>
            </Card>

            <Modal isOpen={isDeleteAllModalOpen} toggle={() => !isDeletingAll && setIsDeleteAllModalOpen(false)} centered>
                <ModalHeader toggle={() => !isDeletingAll && setIsDeleteAllModalOpen(false)}>
                    Confirmation
                </ModalHeader>
                <ModalBody>
                    Êtes-vous sûr de vouloir supprimer toutes les transactions PAYÉ ou ANNULÉ ?
                </ModalBody>
                <ModalFooter>
                    <button className='btn btn-secondary' onClick={() => setIsDeleteAllModalOpen(false)} disabled={isDeletingAll}>
                        Annuler
                    </button>
                    <button className='btn btn-danger' onClick={handleDeleteAllConfirm} disabled={isDeletingAll}>
                        {isDeletingAll ? (
                            <span className='spinner-border spinner-border-sm'></span>
                        ) : (
                            'Confirmer'
                        )}
                    </button>
                </ModalFooter>
            </Modal>


        </Fragment>
    );
};

export default TabClass;
